module.exports = __webpack_public_path__ + "static/media/facebook-white.3b0d4d6d.svg";